$(() => {
    /**
     * START: Click event listener for #chat-with-us. Used as an in modal
     */
    $(document).on('click', '#chat-with-us', () => {
        if ($("div.LandbotLivechat.is-open").length === 0) {
            if (myLandbotConfigUrl && myLandbotConfigUrl.length > 0) {
                const csLandbot = new Landbot.Livechat({
                    configUrl: myLandbotConfigUrl,
                });
                csLandbot.onLoad(() => {
                    csLandbot.open();
                });
            }
        } 
    });
    /**
     * END: #chat-with-us
     */
});